import {Box, Typography} from '@mui/material';
import './SelectAnalyzers.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SelectAnalyzersTable from './select-analyzers-table/SelectAnalyzerTables';
import AnalyzerDetailsFlyout from './analyzer-details-flyout/AnalyzerDetailsFlyout';
import {useState} from 'react';
import NonEditableFieldFlyout from './non-editable-field-flyout/NonEditableFieldFlyout';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../redux/store';

const SelectAnalyzers: React.FC = () => {
  const {t} = useTranslation();

  const {isReadOnlyView} = useSelector(
    (state: RootState) => state.indexManagement
  );

  const [isAnalyzerDetailsFlyoutOpen, setIsAnalyzerDetailsFlyoutOpen] =
    useState<boolean>(false);
  const [isNonEditableFieldsFlyoutOpen, setIsNonEditableFieldsFlyoutOpen] =
    useState<boolean>(false);

  return (
    <Box className="select-analyzers-container">
      <Box className="select-analyzers">
        <Typography
          tabIndex={0}
          aria-label="select-analyzer-heading"
          className="select-analyzers__heading typo-text subhead2_size"
          data-testid={`select-analyzers-heading`}>
          {t('indexManagement.customIndex.selectAnalyzer.heading')}
        </Typography>
        <Box className="select-analyzers__content">
          <Box className="select-analyzers__header">
            <Box className="select-analyzers__header-text">
              <Typography
                tabIndex={0}
                className="typo-text subhead3_size"
                data-testid={`select-analyzers-sub-heading`}>
                {t('indexManagement.customIndex.selectAnalyzer.subHeading')}
              </Typography>
              <Typography
                tabIndex={0}
                className="select-analyzers__description typo-text body2_size"
                data-testid={`select-analyzers-description`}>
                {t('indexManagement.customIndex.selectAnalyzer.description')}
              </Typography>
            </Box>
            <ArrButton
              size="medium"
              dataTestId="analyzer-details-flyout-btn"
              aria-label="Open Analyzer Details"
              onClick={() => setIsAnalyzerDetailsFlyoutOpen(true)}
              endIcon={<KeyboardArrowRightIcon fontSize="medium" />}
            >
              {isReadOnlyView
                ? t('indexManagement.customIndex.readOnly.viewAnalyzers')
                : t(
                    'indexManagement.customIndex.selectAnalyzer.analyzerDetailsButton'
                  )}
            </ArrButton>
          </Box>
          <SelectAnalyzersTable />
          {!isReadOnlyView && (
            <ArrButton
              size="medium"
              variant="text"
              dataTestId="non-editable-flyout-btn"
              className="non-editable-button"
              aria-label="View non-editable fields"
              onClick={() => setIsNonEditableFieldsFlyoutOpen(true)}
              endIcon={<KeyboardArrowRightIcon fontSize="medium" />}
            >
              {t(
                'indexManagement.customIndex.selectAnalyzer.viewNonEditableFied',
                {
                  count: 124,
                }
              )}
            </ArrButton>
          )}
        </Box>
        <AnalyzerDetailsFlyout
          isOpen={isAnalyzerDetailsFlyoutOpen}
          onClose={() => setIsAnalyzerDetailsFlyoutOpen(false)}
        />
        <NonEditableFieldFlyout
          isOpen={isNonEditableFieldsFlyoutOpen}
          onClose={() => setIsNonEditableFieldsFlyoutOpen(false)}
        />
      </Box>
    </Box>
  );
};

export default SelectAnalyzers;
